'use client';

import {ANNOTATIONS_URL} from 'config';
import {SquarePen} from 'lucide-react';
import {useState} from 'react';

interface Props {
  slug: string;
  // The public page only has the guide's slug; this resolves it to the ops-side
  // generation/version id server-side and redirects.
  lookupPath: 'guides' | 'company-guides';
}

// Admin-only shortcut into the annotations dashboard, styled and behaving like
// Astro's dev toolbar: a bar docked at the bottom that stays mostly off-screen,
// peeking a sliver, and slides fully into view on hover.
//
// Anchored flush at bottom-0 (no resting gap): the hover-triggered slide-up must
// keep the cursor inside the box for every frame of the transition, or the box
// slides out from under the pointer mid-animation and mouseenter/mouseleave
// flip-flop (hover -> slide up -> pointer no longer over box -> unhover -> slide
// down -> pointer over box again -> hover...). A bottom gap broke that invariant.
export function AdminEditButton({slug, lookupPath}: Props) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={`fixed bottom-0 left-1/2 z-2100 -translate-x-1/2 rounded-t-lg bg-iq-yellow p-1.5 transition-all duration-300 ease-out ${
        hovered
          ? 'translate-y-0 shadow-[0_8px_20px_rgba(0,0,0,0.43)]'
          : 'translate-y-9 shadow-[0_0_15px_rgba(0,0,0,0.43)]'
      }`}>
      <a
        href={`${ANNOTATIONS_URL}/api/${lookupPath}/by-slug/${slug}`}
        target='_blank'
        rel='noopener noreferrer'
        className='flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-iq-black transition-colors hover:bg-black/10'>
        <SquarePen className='w-4 h-4' />
        Edit guide
      </a>
    </div>
  );
}
